import Swiper from 'swiper';
import {
    Autoplay
} from 'swiper/modules';
import 'swiper/css';

const SLIDE_WIDTH_PC = 480;
const SLIDE_WIDTH_SP = 280;
const SPACE = 12;
const SM_BREAKPOINT = 768;

const storeGallery = () => {
    const el = document.querySelector('.js-store-gallery-swiper');
    if (!el) return;

    const wrapper = el.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(el.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;
    if (originalCount === 0) return;

    const slideWidth = window.innerWidth <= SM_BREAKPOINT ? SLIDE_WIDTH_SP : SLIDE_WIDTH_PC;
    const visibleCount = Math.ceil((el.offsetWidth + SPACE) / (slideWidth + SPACE));
    const minRequired = visibleCount * 2;

    if (originalCount < minRequired) {
        const times = Math.ceil(minRequired / originalCount);
        for (let i = 1; i < times; i++) {
            originalSlides.forEach(slide => {
                wrapper.appendChild(slide.cloneNode(true));
            });
        }
    }

    new Swiper(el, {
        modules: [Autoplay],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: SPACE,
        centeredSlides: false,
        speed: 8000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        allowTouchMove: true,
    });
};

export default storeGallery;
